<template>
  <div>
    <navigation></navigation>

    <div class="container px-4 mx-auto">
      <h1 class="mb-3">Register</h1>
      <register-form></register-form>
    </div>
  </div>
</template>

<script>
import Navigation from "./Navigation.vue";
import RegisterForm from "./RegisterForm";

export default {
  data() {
    return {
      user: {}
    };
  },

  components: {
    Navigation,
    RegisterForm,
  },
};
</script>
